import { makeHttpRequest } from "@/shared";

import { mapCalculatedRentFromServer } from "./mappers/mapCalculatedRentFromServer";

export const removeDepositFromRent = async (sessionKey, id) => {
    const response = (
        await makeHttpRequest({
            url: `/rent/builder/${sessionKey}/remove/deposit`,
            method: "DELETE",
            params: {
                deposit_id: Number(id),
            },
        })
    ).data;

    return mapCalculatedRentFromServer(response.data);
};
